<template>
  <div id="app">
    <md-toolbar class="md-primary">
      <h3 class="md-title">UVS Compras</h3>
    </md-toolbar>
    <div class="container">
      <h1 class="md-headline">Como ativar a sua contribuição</h1>
      <h2
        class="md-body-1"
      >Clique em "IR PARA A LOJA" em uma das lojas parceiras abaixo e faça as suas compras normalmente. Um percentual do valor da sua compra será destinado à construção do <a target="_blank" href="https://projetoviladaserra.com.br/">Colégio Logosófico Unidade Vila da Serra</a>.</h2>
    </div>
    <div class="searchbar">
      <md-field>
        <label>Pesquisar loja...</label>
        <md-input v-model.trim="searchText" v-focus></md-input>
      </md-field>
    </div>
    <div class="container md-layout">
      <div
        class="store md-layout-item md-medium-size-33 md-large-size-33 md-small-size-50 md-xsmall-size-100"
        v-for="store in filteredStores"
        :key="store.name"
      >
        <md-card>
          <md-card-header>
            <md-card-header-text>
              <div class="md-title">{{ store.name }}</div>
              <div class="md-subhead">Comissão máxima: {{ store.maxCommission }}%</div>
            </md-card-header-text>

            <md-card-media>
              <img :src="store.logoSrc" :alt="'Logomarca da loja ' + store.name">
            </md-card-media>
          </md-card-header>

          <md-card-actions>
            <md-button
              @click="registerEventWithAnalytics(store.name)"
              :href="store.href"
              target="_blank"
            >Ir para a loja</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      searchText: "",
      stores: [
        {
          name: "Eletrolux",
          href: "https://compre.vc/v2/34376792412",
          maxCommission: 1.48,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6078/logo_185x140.png",
        },
        {
          name: "Rio Quente",
          href: "https://compre.vc/v2/3436cb4a60b",
          maxCommission: 5.92,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6401/logo_185x140.png",
        },
        {
          name: "Drogaria Liviero",
          href: "https://compre.vc/v2/3432778b34d",
          maxCommission: 6.27,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6635/logo_185x140.png",
        },
        {
          name: "LeluPets",
          href: "https://compre.vc/v2/3432bdbe94e",
          maxCommission: 5.92,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6776/logo_185x140.png",
        },
        {
          name: "Papel Arte",
          href: "https://compre.vc/v2/34348061ccc",
          maxCommission: 5.55,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7198/logo_185x140.png",
        },
        {
          name: "Loja Madesa",
          href: "https://compre.vc/v2/34381aaedb6",
          maxCommission: 7.4,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7183/logo_185x140.png",
        },
        {
          name: "Efácil",
          href: "https://compre.vc/v2/343a61f76f7",
          maxCommission: 2.22,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/5779/logo_185x140.png",
        },
        {
          name: "Gazin",
          href: "https://compre.vc/v2/34300281068",
          maxCommission: 3.7,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6280/logo_185x140.png",
        },
        {
          name: "Eletrum",
          href: "https://compre.vc/v2/3438d4d98af",
          maxCommission: 2.59,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6040/logo_185x140.png",
        },
        {
          name: "Livrarias Curitiba",
          href: "https://compre.vc/v2/34373558254",
          maxCommission: 6.36,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7813/logo_185x140.png",
        },
        {
          name: "Positivo",
          href: "https://compre.vc/v2/34390ce21f5",
          maxCommission: 5.18,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6117/logo_185x140.png",
        },
        {
          name: "Vaio",
          href: "https://compre.vc/v2/343f0d86512",
          maxCommission: 2.22,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6126/logo_185x140.png",
        },
        {
          name: "Wondershare",
          href: "https://compre.vc/v2/343277fd010",
          maxCommission: 7.4,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6924/logo_185x140.png",
        },
        {
          name: "Lenovo Brasil",
          href: "https://compre.vc/v2/3434b921990",
          maxCommission: 3.26,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/5798/logo_185x140.png",
        },
        {
          name: "Compaq",
          href: "https://compre.vc/v2/343c3a5ee58",
          maxCommission: 2.07,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7958/logo_185x140.png",
        },
        {
          name: "Asus",
          href: "https://compre.vc/v2/343c9042dcc",
          maxCommission: 1.85,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6111/logo_185x140.png",
        },
        {
          name: "Ano Zero",
          href: "https://compre.vc/v2/3432488769a",
          maxCommission: 8.88,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7849/logo_185x140.png",
        },
        {
          name: "Kidy Calçados",
          href: "https://compre.vc/v2/34311c3d4fa",
          maxCommission: 11.73,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7574/logo_185x140.png",
        },
        {
          name: "Nautika Lazer",
          href: "https://compre.vc/v2/343ba269da4",
          maxCommission: 8.97,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6849/logo_185x140.png",
        },
        {
          name: "VentureShop",
          href: "https://compre.vc/v2/3433777fd28",
          maxCommission: 4.14,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7928/logo_185x140.png",
        },
        {
          name: "Gorila Shield",
          href: "https://compre.vc/v2/3433c4e3748",
          maxCommission: 3.7,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7451/logo_185x140.png",
        },
        {
          name: "Quero Case",
          href: "https://compre.vc/v2/343e51362b8",
          maxCommission: 11.1,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7641/logo_185x140.png",
        },
        {
          name: "2AM Gaming",
          href: "https://compre.vc/v2/34346b3be03",
          maxCommission: 3.7,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6246/logo_185x140.png",
        },
        {
          name: "FotoLux",
          href: "https://compre.vc/v2/3436c51446e",
          maxCommission: 5.18,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/8266/logo_185x140.png",
        },
        {
          name: "Xiaomi",
          href: "https://compre.vc/v2/343d2acfc61",
          maxCommission: 2.42,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6826/logo_185x140.png",
        },
        {
          name: "Girafa",
          href: "https://compre.vc/v2/343327da088",
          maxCommission: 2.22,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/5727/logo_185x140.png",
        },
        {
          name: "Polishop",
          href: "https://compre.vc/v2/3432be9d5b4",
          maxCommission: 2.96,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/158/logo_185x140.png",
        },
        {
          name: "Electrolux",
          href: "https://compre.vc/v2/34376792412",
          maxCommission: 1.48,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6078/logo_185x140.png",
        },
        {
          name: "Walita / Philips",
          href: "https://compre.vc/v2/343f53171b8",
          maxCommission: 1.48,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/8443/logo_185x140.png",
        },
        {
          name: "Dako",
          href: "https://compre.vc/v2/34394aa44d7",
          maxCommission: 2.96,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6517/logo_185x140.png",
        },
        {
          name: "ShopClub",
          href: "https://compre.vc/v2/3432722dd5c",
          maxCommission: 1.85,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6575/logo_185x140.png",
        },
        {
          name: "Orthocrin",
          href: "https://compre.vc/v2/343751b7f4b",
          maxCommission: 8.28,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/8162/logo_185x140.png",
        },
        {
          name: "Loja Oficial Kärcher",
          href: "https://compre.vc/v2/34312d9797d",
          maxCommission: 1.72,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/7173/logo_185x140.png",
        },
        {
          name: "Só para organizar",
          href: "https://compre.vc/v2/34311ae2269",
          maxCommission: 7.4,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6284/logo_185x140.png",
        },
        {
          name: "Ribsol energia solar",
          href: "https://compre.vc/v2/343c1749185",
          maxCommission: 5.92,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6285/logo_185x140.png",
        },
        {
          name: "Palácio das Ferramentas",
          href: "https://compre.vc/v2/343be599fca",
          maxCommission: 2.42,
          logoSrc:
            "https://www.socialsoul.com.vc/programas/BR/6974/logo_185x140.png",
        },
      ],
    };
  },
  methods: {
    registerEventWithAnalytics(storeName) {
      window.ga("send", "event", "ViewStoreButton", "click", storeName);
    },
  },
  computed: {
    filteredStores() {
      return this.stores.filter((store) => {
        if (!this.searchText) return true;
        const storeName = store.name.toLowerCase();
        const searchText = this.searchText.toLowerCase().replace(/'/g, "");
        return storeName.includes(searchText);
      });
    },
  },
  mounted() {
    this.stores.sort((store1, store2) => {
      if (store1.name < store2.name) return -1;
      else if (store1.name > store2.name) return 1;
      return 0;
    });
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}

#app {
  height: 100%;
  overflow: auto;
}

.searchbar {
  padding: 0 16px;
}

.container {
  padding: 16px;
}

.store {
  padding: 8px;
}

@media (min-width: 600px) {
  .searchbar {
    padding: 0 32px;
  }
  .container {
    padding: 32px;
  }
}

@media (min-width: 900px) {
  .searchbar {
    padding: 0 64px;
  }
  .container {
    padding: 64px;
  }
}
</style>
